<template>
  <div>
    <vimeo-player ref="player" :video-id="videoId"/>
  </div>
</template>

<script>

import vueVimeoPlayer from 'vue-vimeo-player';

export default {
  name: "VueVimeo",
  props: {
    videoId: {
      type: String,
      required: true
    },
    options: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    playVideo() {
      this.player.playVideo()
    },
    playing() {
      //console.log('\o/ we are watching!!!')
    }
  },
  computed: {
    player() {
      return this.$refs.youtube.player
    }
  }
}
</script>

<style>

iframe {
  /*width: 100%;*/
  max-width: 800px; /* Also helpful. Optional. */
}

</style>